export enum UpdateTaskStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  FAILED_WITH_TERMINAL_ERROR = "FAILED_WITH_TERMINAL_ERROR",
}
